import { render, staticRenderFns } from "./TouchHoldKey.vue?vue&type=template&id=27fb34c0&"
import script from "./TouchHoldKey.vue?vue&type=script&lang=js&"
export * from "./TouchHoldKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports